import { BedarfStatus, BedarfStatusConfig } from '../../types/bedarf';

interface BedarfStatusBadgeProps {
  status: BedarfStatus;
  size?: 'sm' | 'md';
}

export function BedarfStatusBadge({ status, size = 'md' }: BedarfStatusBadgeProps) {
  const config = BedarfStatusConfig[status] || { label: status, color: 'text-gray-700', bgColor: 'bg-gray-100' };

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-2.5 py-0.5 text-sm';

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${config.bgColor} ${config.color} ${sizeClasses}`}
    >
      {config.label}
    </span>
  );
}
